import React from "react";
import { motion } from "framer-motion";

const stats = [
  { value: "5500+", label: "Clients Served" },
  { value: "40+", label: "Industries Covered" },
  { value: "30+", label: "Years of Experience" },
  // { value: "98%", label: "Success Rate" },
];

export default function WhyChooseUs() {
  return (
    <div className="bg-[#0F172A] text-white w-full  py-12 px-6 md:px-12">
      {/* Section Title */}
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-goldenYellow uppercase">
          Our Professional Values
        </h2>
        <div className="w-24 h-1 bg-goldenYellow mx-auto mt-2 rounded-full"></div>
      </div>

      {/* Stats Grid */}
      <div className=" flex md:flex-row flex-col  w-full  gap-6 text-center">
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            className="bg-[#16213D] md:w-1/3 p-6 py-9 rounded-lg shadow-md hover:shadow-lg hover:shadow-goldenYellow transition duration-300"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-4xl font-bold text-goldenYellow">{stat.value}</h3>
            <p className="text-gray-300 text-lg">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
